import { FC } from 'react';
import { cn } from '@/lib/utils';
import { useTranslation } from 'react-i18next';

type Props = {
    status: boolean;
    className?: string;
};

const ReleaseStatus: FC<Props> = ({ status, className }) => {
    const { t } = useTranslation();

    return status ? (
        <span className={cn('text-sm text-success-1000', className)}>
            {t('main.releases.status.active')}
        </span>
    ) : (
        <span className={cn('text-sm text-error-1000', className)}>
            {t('main.releases.status.inactive')}
        </span>
    );
};

export default ReleaseStatus;
